import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="cursor-pointer">
              <span className="font-heading text-2xl font-bold text-accent-500">
                吃瓜
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">
                在线
              </span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              最新娱乐资讯聚合平台，聚焦明星八卦、网红动态、综艺热点与影视资讯。一手吃瓜速递，精彩不容错过。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-secondary-700 flex items-center justify-center hover:bg-accent-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              内容分类
            </h4>
            <div className="flex flex-col gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              关于我们
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                品牌介绍
              </Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                联系我们
              </Link>
              <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                用户协议
              </a>
              <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                隐私政策
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">
              {t('subscribe')}
            </h4>
            <p className="text-sm text-foreground-300 mb-4">{t('subscribe_desc')}</p>
            <form
              className="flex"
             
              onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.currentTarget);
                const honeypot = formData.get('website_alt') as string;
                if (honeypot && honeypot.trim() !== '') return;
              }}
            >
              <div className="honeypot-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <div className="flex w-full">
                <input
                  type="email"
                  name="email"
                  placeholder={t('subscribe_placeholder')}
                  required
                  className="flex-1 bg-secondary-800 border border-secondary-700 rounded-l-md px-4 py-2.5 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-accent-500"
                />
                <button
                  type="submit"
                  className="bg-accent-500 hover:bg-accent-600 text-background-50 px-5 py-2.5 rounded-r-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  {t('subscribe_btn')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-foreground-500">{t('copyright')}</p>
          <p className="text-sm text-foreground-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}